import React from 'react';

const LegendPopulation = () => (
  <div className="leyenda-segregacion">
      <div className="texto-superior">
        <div className="textoizda">
          <span><strong>Menos</strong> pob. extr.</span><br/>
          <span style={{paddingLeft: '20px', fontWeight: 900}}>|</span>
        </div>
        <div className="textodcha">
          <span><strong>Más</strong> pob. extr.</span><br/>
          <span style={{paddingRight: '40px', fontWeight: 900}}>|</span>
        </div>
      </div>
      <div className="leyenda-doble">
        <div className="coropletas">
          <div className="step color5-poblacion"></div> 
          <div className="step color4-poblacion"></div>
          <div className="step color3-poblacion"></div>
          <div className="step color2-poblacion"></div>
          <div className="step color1-poblacion"></div>
        </div>
      </div> 
    </div>
);

export default LegendPopulation;